import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { provide } from 'vue'
import Home from '@/views/marketing/index/index.vue'


const __default__ = { name: 'DcCosFbuDataReport' }


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

enum Subdomain {
  Fbu = 'fbu',
  Lbu = 'lbu'
}
provide('subdomain', Subdomain.Fbu)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Home))
}
}

})